// AUTO-GENERATED — do not edit manually.
// Add photos to public/assets/portfolio/<category>/ and run: npm run generate:portfolio

export const portfolioCategories = [
  {
    "slug": "event-photography",
    "title": "Событийная съёмка",
    "cover": "/assets/portfolio/event-photography/7010naoto-nature-9715206_1920.jpg",
    "photos": [
      "/assets/portfolio/event-photography/7010naoto-nature-9715206_1920.jpg"
    ]
  }
];
